/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";
import { getTheme } from "office-ui-fabric-react";

const theme = getTheme();
/**
 * Styled component that returns error message in red.
 */
export const RedText = styled.p`
  color: ${theme.palette.red};
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
